<!--  -->
<!-- =========================================== -->
<script lang="ts">import ABOUT_ABOUT from "./components/about_about.svelte";
import ABOUT_FEATURES from "./components/about_features.svelte";
import ABOUT_LINKS from "./components/about_links.svelte";
</script>

<!--  -->
<!-- =========================================== -->
<!--  -->

<!-- ABOUT PAGE -->
<!-- ABOUT_PAGE -->
<section>
  <h1>ABOUT</h1>
  <ABOUT_ABOUT />
  <ABOUT_FEATURES />
  <p>USE AT YOUR OWN RISK.</p>
  <ABOUT_LINKS />
  <p></p>
</section>
